module.exports = __webpack_public_path__ + "img/update.ff402e62.svg";